import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { deleteDelays, getDelays } from "../../../actions/delay/delay";
import DelayListComponent from "../../../components/Definition/Delays/DelayListComponent";
import { deleteWeight } from "../../../actions/weight/weight";

export default function DelayScreen() {
    const [destination, setDestination] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getDelays(params.toString());
                setLoading(false);
                setDestination(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <DelayListComponent lists={destination} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید تاخیر حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteDelays(id);
                    if (response.status === "success") {
                        toast.success("تاخیر حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف تاخیر");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
